<template>
  <div id="app">
    <router-view></router-view>
    <!-- <router-view v-else></router-view> -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { fetchList } from '@/api/sys/dict';

// 需要 reload 页面的路径
const NEED_RELOAD_PAGES = ['/ums/createMember'];

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  computed: {
    ...mapGetters(['dicList'])
  },
  methods: {
    ...mapActions(['SetDic']),
    reload() {
      if (NEED_RELOAD_PAGES.find(path => window.location.href.includes(path))) {
        window.location.reload();
        return;
      }

      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    }
  },
  mounted() {
    if (!this.dicList || this.dicList.length === 0) {
      fetchList({
        pageNum: 1,
        pageSize: 99999
      }).then(response => {
        const dicList = response.data.records;
        dicList.forEach(item => (dicList[item.type] = item));
        this.SetDic(dicList);
      });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue